import script from "./IDEA_ACTIVITY_CREATED.vue?vue&type=script&setup=true&lang=ts"
export * from "./IDEA_ACTIVITY_CREATED.vue?vue&type=script&setup=true&lang=ts"

import "./IDEA_ACTIVITY_CREATED.vue?vue&type=style&index=0&id=15bfe207&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15bfe207"]])

export default __exports__